module.exports = __webpack_public_path__ + "img/Span-10.230bc7e7.jpg";